import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Transcoder, TranscoderSimple} from '../models/transcoder.model';
import {mapSearchListResponse} from '../helpers/search.helper';
import {SearchQueryParams} from '../models/search-query-params.model';
import {Observable} from 'rxjs';

@Injectable()
export class TranscoderService {
    private baseUrl = '/api/secured/transcoder';

    constructor(private http: HttpClient) {}

    fetchList(props: SearchQueryParams) {
        return this.http
            .get(this.baseUrl, {params: props.getHttpParams(), observe: 'response'})
            .pipe(mapSearchListResponse<Transcoder>(Transcoder));
    }

    add(data: Transcoder) {
        return this.http.post<Transcoder>(this.baseUrl, {...data});
    }

    fetchById(id: number) {
        return this.http.get<Transcoder>(`${this.baseUrl}/${id}`);
    }

    delete(id: number) {
        return this.http.delete<Transcoder>(`${this.baseUrl}/${id}`);
    }

    update(data: Transcoder) {
        return this.http.put<Transcoder>(`${this.baseUrl}/${data.id}`, {...data});
    }

    searchIndex(indexSearch: string): Observable<TranscoderSimple[]> {
        return this.http.get<TranscoderSimple[]>(`${this.baseUrl}/search/${indexSearch}`);
    }
}
